import { Email, Phone } from "@mui/icons-material";

import TextInputField from "../../../Fields/TextInputField";

export default function ContactInfoFields({ email, phone, onChange }) {
  return (
    <div className="pb-4">
      <div className="flex gap-6 py-4">
        <TextInputField
          label="Email"
          placeholder="Add Email"
          value={email}
          onChange={onChange("email")}
          className="w-1/2"
        />
        <TextInputField
          label="Phone Number"
          placeholder="Add Phone Number"
          value={phone}
          onChange={onChange("phone")}
          className="w-1/2"
        />
      </div>
      <p className="ml-1 text-[12px] text-gray-400">
        Enter at least 1 valid form of contact information. <Email className="text-[16px]" /> or{" "}
        <Phone className="text-[16px]" />
      </p>
    </div>
  );
}
